import React from 'react';
import { Edit, Create, SimpleForm, TextInput, ReferenceArrayInput, SelectArrayInput } from 'react-admin';

export const ProductFeatureEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="name" label="Internal Name (camelCase)" helperText="e.g., lactationOnDemand" />
            <TextInput source="display_name" label="Display Name" />
            <TextInput source="description" multiline />
            <ReferenceArrayInput source="role_ids" reference="roles" label="Mapped Roles">
                <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
        </SimpleForm>
    </Edit>
);

export const ProductFeatureCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" label="Internal Name (camelCase)" helperText="e.g., lactationOnDemand" required />
            <TextInput source="display_name" label="Display Name" required />
            <TextInput source="description" multiline />
            <ReferenceArrayInput source="role_ids" reference="roles" label="Mapped Roles">
                <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
        </SimpleForm>
    </Create>
);

